var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0.5C10.6904 0.5 11.25 1.05964 11.25 1.75V19.25C11.25 19.9404 10.6904 20.5 10 20.5C9.30964 20.5 8.75 19.9404 8.75 19.25V1.75C8.75 1.05964 9.30964 0.5 10 0.5Z",
    fill: "#0050AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.5C0 9.80964 0.559644 9.25 1.25 9.25H18.75C19.4404 9.25 20 9.80964 20 10.5C20 11.1904 19.4404 11.75 18.75 11.75H1.25C0.559644 11.75 0 11.1904 0 10.5Z",
    fill: "#0050AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBlue);
export default __webpack_public_path__ + "static/media/plus-blue.fcd68c06d55c831a9f657d416fbd976b.svg";
export { ForwardRef as ReactComponent };